<template>
  <div>
    <v-row justify="center">
      <v-col md="8">
        <DriverCard
            class="mb-6"
            v-for="(booking, i) of bookings"
            :key="i"
            :booking="booking"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col md="8" v-if="this.bookings.length < 1">
        <h2 align="center" class="primary--text"> {{ title }} </h2>
        <h3 align="center" class="primary--text"> {{ subTitle }} </h3>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import DriverCard from '@/components/drivers/dashboard/DriverCard';

export default {
  name: 'DriverTabs',
  props: {
    bookings: Array
  },
  components: {
    DriverCard
  },
  data() {
    return {
      title: '',
      subTitle: ''
    }
  },
  methods: {
    isEmptyCheck() {
      if (this.bookings.length < 1) {
        this.title = 'There are no bookings yet...';
        this.subTitle = 'Please stand by for more booking orders';
      }
    }
  },
  mounted() {
    this.isEmptyCheck();
  }
}
</script>

<style lang="scss" scoped>

</style>